import { classNames } from 'shared/lib/classNames/classNames';
import { ReactNode, useEffect, useState } from 'react';
import cls from './LazyBackground.module.scss';

interface LazyBackgroundProps {
    className?: string
    tnImg: any
    originalImg: any
    children?: ReactNode
    overlay?: string
}

export const LazyBackground = (props: LazyBackgroundProps) => {
    const {
        className,
        tnImg,
        originalImg,
        children,
        overlay,
    } = props;
    const [source, setSource] = useState(null);

    useEffect(() => {
        const img = new Image();

        // Timeout вешаем для firefox, так как грузит сначала большое изображение
        setTimeout(() => {
            img.src = originalImg;
            img.onload = () => setSource(originalImg);
        }, 10);
    }, [originalImg]);

    return (
        <div
            className={classNames(cls.LazyBackground, {}, [className])}
            style={{ backgroundImage: `url(${source || tnImg})` }}
        >
            {overlay
                && (
                    <div
                        className={cls.overlay}
                        style={{ background: `${overlay}` }}
                    />
                )}
            {children}
        </div>
    );
};
